import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";
export const savesignaturesApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SIGNATURES.ADD, 
    data: payload, 
  });
};

export const fetchallsignatures= async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.SIGNATURES.GET_ALL, 
    params: {
      ...params,
     
    },
  });
};
export const updatesignaturesApi = async ({ uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.SIGNATURES.UPDATE}?coll=Signature&uiid=${uiid}`,
    data: payload,
  
  });
};
